import React from "react";

interface UploadProgressProps {
  progress: number; // 0-100
  fileName?: string;
  currentFile?: number;
  totalFiles?: number;
}

const UploadProgress: React.FC<UploadProgressProps> = ({ progress, fileName, currentFile, totalFiles }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-6 border border-gray-100 animate-in fade-in zoom-in duration-300">
        <div className="flex flex-col items-center justify-center text-center space-y-4">
          
          <div className="p-3 bg-blue-50 rounded-full">
            <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
          </div>

          <div>
            <h3 className="text-xl font-bold text-gray-800">
              Dosyalar Yükleniyor...
            </h3>
            <p className="text-sm text-gray-500 mt-1 line-clamp-1">
              {fileName ? fileName : "Lütfen bekleyin, işlem tamamlananakadar sayfadan ayrılmayın."}
            </p>
          </div>

          <div className="w-full flex items-center justify-between mb-1">
            <span className="text-sm font-semibold text-gray-700">İlerleme</span>
            <span className="text-sm font-bold text-blue-600">{progress}%</span>
          </div>
          
          <div className="w-full bg-gray-100 rounded-full h-3 overflow-hidden shadow-inner">
            <div
              className="bg-gradient-to-r from-blue-500 to-indigo-600 h-full rounded-full transition-all duration-300 ease-out relative"
              style={{ width: `${progress}%` }}
            >
               <div className="absolute inset-0 bg-white/20 animate-pulse" />
            </div>
          </div>
          
          {totalFiles && totalFiles > 1 && (
            <div className="text-xs font-medium text-gray-500 bg-gray-100 px-3 py-1 rounded-full mt-2">
              Dosya {currentFile} / {totalFiles}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UploadProgress;
